import template from './page-title.html';

const PageTitleComponent = {
    bindings: {
        title: '<',
        icon: '<'
    },
    template,
};

export default PageTitleComponent;



// WEBPACK FOOTER //
// ./app/common/page-title/page-title-component.js